export default __webpack_public_path__ + "static/media/brago-screenshot-06.35b63686.png";